// extracted by mini-css-extract-plugin
export default {"health":"health_health__JACz7","btn":"health_btn__pA8tg"};